// extracted by mini-css-extract-plugin
export var companyInformation = "AccountManager-module__companyInformation___uHMvb";
export var containerRow = "AccountManager-module__containerRow___cZYb+";
export var createAccountButton = "AccountManager-module__createAccountButton___3rzCE";
export var emailContainer = "AccountManager-module__emailContainer___kBoKQ";
export var large = "1084px";
export var learnMoreMsa = "AccountManager-module__learnMoreMsa___COMZp";
export var learnMoreMsaLink = "AccountManager-module__learnMoreMsaLink___ziguz";
export var signInSubtitle = "AccountManager-module__signInSubtitle___yFL8t";
export var subtitleColumn = "AccountManager-module__subtitleColumn___aV6mu";